import { InformationCircleIcon } from "@heroicons/react/outline";

import { PopoverContent } from "../popover";

import { InputVariablePopoverItem } from "./InputVariablePopoverItem";

import type { RequestInputVariables } from "@/queries/requests/useRequestLogInputVariables";

interface InputVariablesPopoverContentProps {
  variables: RequestInputVariables;
  requestId?: string | number | null;
}

const InputVariablesPopoverContent = ({
  variables,
  requestId,
}: InputVariablesPopoverContentProps) => (
  <PopoverContent
    onClick={e => e.stopPropagation()}
    className="flex max-h-[80vh] w-[600px] flex-col lg:max-h-[45vh]"
  >
    <div className="flex items-center space-x-2 px-4 py-3">
      <div>
        <InformationCircleIcon className="inline h-6 text-gray-600" />
      </div>
      <div className="flex-1">
        <div className="text-sm text-gray-800">Input Variables</div>
        <div className="text-xs text-gray-600">
          Variables injected into the prompt template for this request.
        </div>
      </div>
    </div>
    <div className="max-h-[80vh] flex-1 overflow-y-auto lg:max-h-[45vh]">
      <div className="h-full ">
        <table className="w-full table-fixed divide-y divide-gray-200">
          <thead className="sticky top-0 bg-white">
            <tr className="text-left text-xs font-medium uppercase tracking-wider text-gray-600">
              <th className="w-1/3 px-4 py-2">Name</th>
              <th className="w-2/3 px-4 py-2">Value</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {Object.entries(variables).map(([key, value]) => (
              <InputVariablePopoverItem
                key={key}
                itemKey={key}
                value={value}
                requestId={requestId}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </PopoverContent>
);

export { InputVariablesPopoverContent };
